module.exports = require("react-immutable-pure-component");


//////////////////
// WEBPACK FOOTER
// external "react-immutable-pure-component"
// module id = 633
// module chunks = 0